import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { StripeApiService } from '@app/services/api/stripe-api.service';
import { AppointmentRequestRefreshService } from '@app/services/appointment-request-refresh.service';
import { AppointmentRequestService } from '@app/services/appointment-request.service';
import { AppointmentService } from '@app/services/appointment.service';
import { ConfigService } from '@app/services/config/config.service';
import { ContentService } from '@app/services/content.service';
import { CreditCardService } from '@app/services/credit-card.service';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalDbService } from '@app/services/local-db.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { LocaleService } from '@app/services/locale.service';
import { PetService } from '@app/services/pet.service';
import { StripeElementsService } from '@app/services/stripe-elements.service';
import { StripeService } from '@app/services/stripe.service';
import { ConfirmationDialogComponent } from 'app-classic/components/confirmation-dialog/confirmation-dialog.component';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { ReviewRequestComponent as NewReviewRequestComponent } from '../../../../app/components/booking-steps/review-request/review-request.component';
import { NavigationService } from './../../../../app/services/navigation.service';

@Component({
    selector: 'app-review-request',
    templateUrl: './review-request.component.html',
    styleUrls: ['./review-request.component.scss'],
    standalone: false,
})
export class ReviewRequestComponent extends NewReviewRequestComponent {
    constructor(
        _router: Router,
        _localStorageService: LocalStorageService,
        public navigationService: NavigationService,
        _featureFlagService: FeatureFlagService,
        _creditCardService: CreditCardService,
        _fb: FormBuilder,
        _stripeElementsService: StripeElementsService,
        _userAccountService: UserAccountService,
        public _dialog: MatDialog,
        public snackBar: MatSnackBar,
        _stripeApiService: StripeApiService,
        _configService: ConfigService,
        _localeService: LocaleService,
        _localDbCache: LocalDbService,
        public contentService: ContentService,
        _stripeService: StripeService,
        _recaptchaV3Service: ReCaptchaV3Service,
        _appointmentService: AppointmentService,
        _appointmentRequestService: AppointmentRequestService,
        _appointmentRequestRefreshService: AppointmentRequestRefreshService,
        _petService: PetService
    ) {
        super(
            _router,
            _localStorageService,
            _featureFlagService,
            _creditCardService,
            _fb,
            _stripeElementsService,
            _userAccountService,
            undefined as any,
            _stripeApiService,
            _configService,
            _localeService,
            _localDbCache,
            _stripeService,
            _recaptchaV3Service,
            _appointmentService,
            _appointmentRequestService,
            _appointmentRequestRefreshService,
            _petService
        );
    }

    protected showErrorMessage(): void {
        //don't auto-close the snackbar, so the user can read the message
        this.snackBar.open('Error initializing credit card form, please refresh the page', 'Close', {
            duration: undefined,
        });
    }

    public onClickNotYou(): void {
        this._dialog.open(ConfirmationDialogComponent, {
            width: '240px',
            data: {
                title: "You'll Be Logged Out",
                description: 'Please log in again using the correct account or continue as a guest.',
            },
        });
    }

    protected setIsLoading(isLoading: boolean): void {
        this.navigationService.setIsLoading(isLoading);
    }
    protected setIsStepFormValid(isValid: boolean): void {
        this.navigationService.setIsStepFormValid(isValid);
    }
    protected shouldShowSpinnerOnButton(value: boolean): void {
        this.navigationService.shouldShowSpinnerOnButton(value);
    }
}
